// Widget de agendamento online (Feature 55 / A1.3; evoluído na Feature 72 —
// Atividade 541 — "botão contextual": este arquivo passou de "só ADICIONA um
// botão Agendar" para "DECIDE o botão" — serviço esconde o nativo e mostra
// "Agendar"; produto mantém o nativo. Nenhum item fica sem botão (fallback
// explícito: se algo estiver mal configurado, o nativo continua visível).
//
// Reuso: injeta/decide o botão na página nativa de detalhe do Website Item
// (webshop `templates/generators/item/item.html`/`item_details.html`) e no
// grid/lista nativos (`webshop.ProductGrid`/`ProductList`,
// `product_ui/grid.js`/`list.js`) SEM tocar nesses templates/arquivos — só
// lê o sinal já exposto (Atividade 540 — data-attribute na página do item,
// `item.imun_servico` no JSON do grid, ver `catalogo.api.get_product_filter_data_loja`)
// e usa `frappe.ui.Dialog` (já carregado nessa página pelo próprio webshop
// via `dialog.bundle.js`).
//
// Site-wide via hooks.web_include_js — roda em toda página pública e sai
// cedo se não houver item agendável na página atual.

// Feature validacao-cpf-no-navegador, task 2.1 — `import` entre bundles é o
// mesmo mecanismo do `controls.bundle.js` do core (esbuild trata arquivo
// `*.bundle.js` como entrypoint ESM). `imun_cpf.js` é puro (sem DOM, sem
// frappe.*), verificado pela task 1.1.
import { imun_cpf_valido, imun_formatar_cpf } from "./imun_cpf.js";

// Task 1.3 (spec loja-agendar-em-toda-pagina) — __() client-side (frappe/
// public/js/frappe/translate.js:13-17, frappe._) lê DIRETO de
// ``frappe._messages``, NUNCA de ``frappe.boot.__messages`` — só
// ``frappe/www/app.html:55`` (shell do Desk, que a loja nunca carrega) faz
// esse espelhamento. ``frappe.boot.__messages`` agora chega em TODA página
// via o hook ``update_website_context`` (``catalogo.jinja_utils.
// injetar_mensagens_loja``, mutando ``context.boot`` antes do
// ``frappe.boot = {{ boot | json }}`` de ``frappe/templates/base.html``
// rodar) — falta só este espelho, feito aqui (site-wide, sem template) em
// vez de repetir a linha em cada override de ``base_scripts``.
// ``frappe.boot`` já existe neste ponto: o ``block base_scripts`` de
// ``base.html`` (linhas 91-98) roda ANTES do loop de ``web_include_js``
// (linhas 100-102) que carrega este bundle — este arquivo é o 1º item de
// ``web_include_js`` (ver ``hooks.py``), então roda cedo, síncrono, antes de
// qualquer ``frappe.ready``.
if (frappe.boot && frappe.boot.__messages) {
	frappe._messages = frappe.boot.__messages;
}

frappe.ready(function () {
	imun_decidir_botao_pagina_item();
	imun_patch_botao_grid();
	imun_patch_card_receita();
	imun_retomar_reserva_pendente();
});

// ---------------------------------------------------------------------------
// Tarefa D (spec 2026-09-03-cadastro-paciente-portal-e-colisao-cpf.md) — Esc
// não pode fechar o modal de agendamento inteiro (descartando os dados já
// digitados) só porque o cliente queria fechar o CALENDÁRIO do datepicker.
//
// bootstrap-datepicker (air-datepicker, ver frappe/form/controls/date.js) e o
// `frappe.ui.Dialog` (bootstrap modal) escutam a MESMA tecla Esc no MESMO
// documento — sem interceptar, Esc fecha os dois de uma vez (ou o modal
// inteiro quando só o calendário deveria fechar). A pilha abaixo (não
// depender de classes CSS do bootstrap, que já nos queimou antes — ver
// feedback_webshop_base_scripts_sem_boot) rastreia só os diálogos que ESTE
// arquivo cria; qualquer outro diálogo do site continua com o Esc nativo.
// ---------------------------------------------------------------------------
var IMUN_MODAIS_AGENDAMENTO_ABERTOS = [];
var IMUN_ESC_GUARD_INSTALADO = false;

function imun_datepicker_aberto_no_dialogo(dialogo) {
	// Usa a API PÚBLICA do air-datepicker (`.visible`/`.hide()`, a mesma que
	// `ControlDate.set_datepicker` já expõe em `control.datepicker`) em vez de
	// adivinhar classes CSS internas da lib — mais robusto a mudanças de
	// versão, e é exatamente o objeto que abre/fecha o calendário de CADA
	// campo Date do diálogo (appointment_date/imun_dob/dob/paciente_dob).
	var fields = (dialogo && dialogo.fields_dict) || {};
	for (var fieldname in fields) {
		if (!Object.prototype.hasOwnProperty.call(fields, fieldname)) {
			continue;
		}
		var control = fields[fieldname];
		if (control && control.datepicker && control.datepicker.visible) {
			return control.datepicker;
		}
	}
	return null;
}

function imun_instalar_guarda_esc_uma_vez() {
	if (IMUN_ESC_GUARD_INSTALADO) {
		return;
	}
	IMUN_ESC_GUARD_INSTALADO = true;
	// Capture phase (3º argumento `true`): garante que ESTE listener roda
	// ANTES do handler nativo do bootstrap modal (que fica no próprio
	// elemento, fase de bubble) — `stopPropagation` na fase de captura
	// impede o evento de sequer alcançar o elemento do modal.
	document.addEventListener(
		"keydown",
		function (e) {
			if (e.key !== "Escape" && e.keyCode !== 27) {
				return;
			}
			var topo = IMUN_MODAIS_AGENDAMENTO_ABERTOS[IMUN_MODAIS_AGENDAMENTO_ABERTOS.length - 1];
			if (!topo) {
				return; // nenhum diálogo NOSSO aberto — Esc nativo de sempre.
			}
			var pickerAberto = imun_datepicker_aberto_no_dialogo(topo);
			if (pickerAberto) {
				pickerAberto.hide();
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}
			// Nenhum datepicker aberto: Esc fecharia o modal inteiro,
			// descartando os dados já preenchidos — confirma antes.
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			frappe.confirm(
				__("Deseja mesmo fechar? Os dados preenchidos neste formulário serão perdidos."),
				function () {
					topo.hide();
				}
			);
		},
		true
	);
}

function imun_registrar_modal_para_esc(dialogo) {
	imun_instalar_guarda_esc_uma_vez();
	IMUN_MODAIS_AGENDAMENTO_ABERTOS.push(dialogo);
	dialogo.$wrapper.on("hidden.bs.modal.imun_esc_guard", function () {
		var idx = IMUN_MODAIS_AGENDAMENTO_ABERTOS.indexOf(dialogo);
		if (idx !== -1) {
			IMUN_MODAIS_AGENDAMENTO_ABERTOS.splice(idx, 1);
		}
	});
}

// Tarefa D: o datepicker de Data de Nascimento abre sempre no mês/ano ATUAL
// (`ControlDate.get_start_date` = hoje) — péssimo para um campo de
// nascimento, que obriga o cliente a clicar "mês anterior" dezenas de vezes.
// `df.options` é repassado cru ao air-datepicker como override (ver
// `ControlDate.get_df_options`/`set_date_options`, que faz
// `{...datepicker_options_padrão, ...get_df_options()}`) — campo Date não usa
// `options` para mais nada, então isto NUNCA colide com outro uso do campo.
// Abre ~30 anos atrás (ano útil para o adulto que mais agenda pela loja);
// digitar a data diretamente (DD/MM/AAAA) sempre funcionou e continua
// funcionando sem depender do calendário.
function imun_opcoes_datepicker_nascimento() {
	var anoInicial = new Date().getFullYear() - 30;
	return { startDate: new Date(anoInicial, 0, 1) };
}

// Reserva como visitante (Task 6) — sessionStorage "imun_reserva_pendente":
// sobrevive à ida ao /login e ao reload do caso "horário sumiu" (ver
// imun_passo_codigo). Carimbado com ``criado_em`` e limpo no fechamento dos
// diálogos "Quase lá"/"Digite o código" quando a pessoa DESISTE (fix round 1
// — achado da review 2026-09-01: sem isso, uma aba que loga bem depois por
// qualquer outro motivo reabria o modal sozinho com data/horário velhos).
var IMUN_RESERVA_PENDENTE_TTL_MS = 30 * 60 * 1000; // 30 min

function imun_guardar_reserva_pendente(escolha) {
	escolha.criado_em = Date.now();
	sessionStorage.setItem("imun_reserva_pendente", JSON.stringify(escolha));
}

function imun_limpar_reserva_pendente() {
	sessionStorage.removeItem("imun_reserva_pendente");
}

// Quem foi ao /login, ou cujo horário sumiu enquanto digitava o código,
// volta/recarrega aqui — reabre o modal com a escolha preservada. O horário
// É REVALIDADO (imun_montar_dialogo_agendamento chama get_horarios de novo
// via preset), porque nunca ficou reservado enquanto a pessoa se
// identificava. Cobre os dois formatos de escolha: item da loja
// (``item_code``) e agendamento direto por profissional (``appointment_type``
// + ``practitioner``, carrossel de médicos — ``medicos_carrossel.js``).
function imun_retomar_reserva_pendente() {
	var pendente = sessionStorage.getItem("imun_reserva_pendente");
	if (!pendente || !frappe.session.user || frappe.session.user === "Guest") {
		return;
	}
	sessionStorage.removeItem("imun_reserva_pendente");
	var e = JSON.parse(pendente);
	if (!e.criado_em || Date.now() - e.criado_em > IMUN_RESERVA_PENDENTE_TTL_MS) {
		// Escolha velha demais — não reabre sozinho com data/horário obsoletos.
		return;
	}
	if (e.item_code) {
		frappe.call({
			method: "imunocare_ecommerce.agendamento.booking.info_agendamento",
			args: { item_code: e.item_code },
			callback: function (r) {
				if (r.message && r.message.agendavel) {
					imun_abrir_dialogo_agendamento({ item_code: e.item_code }, r.message, e);
				}
			},
		});
		return;
	}
	if (e.appointment_type && e.practitioner) {
		// Mesmo padrão do clique original em medicos_carrossel.js: o
		// profissional já foi escolhido no card, sem ida ao backend — só repõe
		// o mesmo params/info que o clique teria montado.
		imun_abrir_dialogo_agendamento(
			{ appointment_type: e.appointment_type },
			{ practitioner: e.practitioner, logged_in: true },
			e
		);
	}
}

// ---------------------------------------------------------------------------
// Página do item (produto único) — Atividade 541
// ---------------------------------------------------------------------------

function imun_decidir_botao_pagina_item() {
	// Atividade 550 (fix): lê o item_code do NOSSO container primeiro
	// (".imun-product-page[data-imun-item-code]", Atividade 540) e só cai para
	// "[data-item-code]" do webshop como FALLBACK. O atributo do webshop vive
	// no botão "Adicionar ao carrinho" (item_add_to_cart.html, upstream), que
	// só renderiza se passar por uma cadeia de condições do carrinho
	// (shopping_cart.cart_settings.enabled; product_info.price e
	// in_stock/allow_items_not_in_stock) — nada disso tem relação com o item
	// ser agendável. Quando essas condições falhavam, "[data-item-code]" não
	// existia em NENHUM lugar da página, a função saía aqui na 1ª linha e o
	// botão "Agendar" sumia silenciosamente, sem erro (bug confirmado no
	// navegador). O nosso container não tem essa dependência.
	var $productPage = $(".imun-product-page").first();
	var item_code = $productPage.attr("data-imun-item-code");
	if (!item_code) {
		var itemEl = document.querySelector("[data-item-code]");
		item_code = itemEl ? itemEl.getAttribute("data-item-code") : null;
	}
	if (!item_code) {
		return;
	}

	// Sinal exposto pela Atividade 540 (templates/generators/item/item.html +
	// catalogo.jinja_utils.imun_sinal_servico) — evita a ida ao backend no
	// caso comum ("produto": mantém o botão nativo tal como já está na tela).
	var sinalServico = $productPage.length && $productPage.attr("data-imun-servico") === "1";
	if (!sinalServico) {
		return;
	}

	// Confirmação/validação completa no backend (agendamento.booking já sabe
	// se o Appointment Type/profissional realmente funcionam) — só ENTÃO
	// esconde o botão nativo. Fallback explícito (SPEC item 4): se
	// `agendavel` vier falso (ex.: Appointment Type foi apagado depois), o
	// botão nativo de produto permanece visível — a página nunca fica sem
	// nenhum botão.
	frappe.call({
		method: "imunocare_ecommerce.agendamento.booking.info_agendamento",
		args: { item_code: item_code },
		callback: function (r) {
			var info = r.message;
			if (!info || !info.agendavel) {
				return;
			}
			imun_esconder_botao_nativo_pagina();
			imun_render_botao_agendar(item_code, info);
		},
	});
}

function imun_esconder_botao_nativo_pagina() {
	// item_add_to_cart.html (webshop, upstream): ".btn-add-to-cart" ("Add to
	// Cart"/"Add to Quote") e ".btn-view-in-cart" ("View in Cart"/"View in
	// Quote") — os dois únicos botões de carrinho da página do item.
	$(".item-cart .btn-add-to-cart, .item-cart .btn-view-in-cart").addClass("d-none");
}

function imun_render_botao_agendar(item_code, info) {
	var $host = $(".item-cart").first();
	if (!$host.length) {
		return;
	}
	var $btn = $(
		'<button type="button" class="btn btn-primary mt-2 imun-btn-agendar">' +
			__("Agendar") +
			"</button>"
	);
	$host.append($btn);

	$btn.on("click", function () {
		// A parede de /login caiu (Reserva como visitante — Task 6): o modal
		// abre para qualquer um; quem não está logado é ramificado para a
		// identificação/verificação dentro do próprio diálogo, no Confirmar
		// (ver imun_montar_dialogo_agendamento/imun_passo_identificacao).
		imun_abrir_dialogo_agendamento({ item_code: item_code }, info);
	});
}

// ---------------------------------------------------------------------------
// Grid/lista de listagem (all-products, categorias) — Atividade 541
//
// Monkey-patch de `webshop.ProductGrid`/`ProductList.get_primary_button`
// (mesmo padrão de `product_grid_style.js`, que já faz o mesmo com
// `get_card_body_html`): guarda a implementação NATIVA e só substitui a
// saída quando `item.imun_servico` vier `1` (enriquecido pelo backend, ver
// `catalogo.api.get_product_filter_data_loja`) — produto continua 100%
// nativo (Add to Cart/Quote, variantes, estoque, preço), sem duplicar essa
// lógica aqui.
// ---------------------------------------------------------------------------

function imun_patch_botao_grid() {
	if (typeof webshop === "undefined") {
		return;
	}

	if (webshop.ProductGrid && !webshop.ProductGrid.prototype._imun_patched) {
		var original_grid_btn = webshop.ProductGrid.prototype.get_primary_button;
		webshop.ProductGrid.prototype.get_primary_button = function (item, settings) {
			if (item.imun_servico) {
				return imun_html_botao_agendar_card(item);
			}
			return original_grid_btn.call(this, item, settings);
		};
		webshop.ProductGrid.prototype._imun_patched = true;
	}

	if (webshop.ProductList && !webshop.ProductList.prototype._imun_patched) {
		var original_list_btn = webshop.ProductList.prototype.get_primary_button;
		webshop.ProductList.prototype.get_primary_button = function (item, settings) {
			if (item.imun_servico) {
				return imun_html_botao_agendar_card(item);
			}
			return original_list_btn.call(this, item, settings);
		};
		webshop.ProductList.prototype._imun_patched = true;
	}
}

// ---------------------------------------------------------------------------
// Change ``venda-sob-receita``, task 5.1 (D8) — badge "Venda sob prescrição
// médica" na LISTA (view "List View", ``webshop.ProductList``). Monkey-patch
// de ``get_row_body_html`` (método real que monta o corpo da linha na lista
// — ``ProductList`` NÃO tem ``get_card_body_html``; esse método é só do
// grid, ver ``apps/webshop/webshop/public/js/product_ui/list.js``). Guarda a
// implementação NATIVA e só ACRESCENTA o badge quando o backend enriqueceu o
// item com ``item.imun_exige_receita`` (``catalogo.api.
// get_product_filter_data_loja``/``_enriquecer_com_exige_receita``) — cobre
// lista inicial e "Carregar mais" com o mesmo código (``product_list_more.
// bundle.js`` reusa ``new webshop.ProductList(...)``, que chama este
// método), sem chamada extra por card. Flag própria
// (``_imun_patched_receita``) pra não colidir com o guard de
// ``imun_patch_botao_grid``.
//
// O GRID (``webshop.ProductGrid``) tem o badge equivalente direto em
// ``product_grid_style.bundle.js`` (nosso próprio ``get_card_body_html``,
// que já reescreve o corpo do card por inteiro) — um segundo monkey-patch
// aqui nunca seria chamado, porque aquele arquivo carrega DEPOIS deste (ver
// ``hooks.py#web_include_js``) e substitui o método sem encadear o anterior.
// ---------------------------------------------------------------------------

function imun_patch_card_receita() {
	if (typeof webshop === "undefined") {
		return;
	}

	if (webshop.ProductList && !webshop.ProductList.prototype._imun_patched_receita) {
		var original_list_row = webshop.ProductList.prototype.get_row_body_html;
		webshop.ProductList.prototype.get_row_body_html = function (item, title, settings) {
			var html = original_list_row.call(this, item, title, settings);
			return item.imun_exige_receita ? imun_html_badge_receita() + html : html;
		};
		webshop.ProductList.prototype._imun_patched_receita = true;
	}
}

function imun_html_badge_receita() {
	return '<span class="imun-badge-receita">Venda sob prescrição médica</span>';
}

function imun_html_botao_agendar_card(item) {
	return (
		'<div class="btn btn-sm btn-primary w-100 mt-2 imun-btn-agendar-card" ' +
		'data-item-code="' +
		frappe.utils.escape_html(item.item_code || "") +
		'">' +
		__("Agendar") +
		"</div>"
	);
}

// Delegado (os cards são recriados a cada render/"Carregar mais" — ver
// product_list_more.js) — clique abre o MESMO diálogo da página do item,
// mas só depois de validar no backend (agendamento.booking.info_agendamento)
// que o serviço realmente está configurado; fallback: se não estiver, avisa
// o cliente em vez de abrir um diálogo quebrado (nunca lança 500).
frappe.ready(function () {
	$(document).on("click", ".imun-btn-agendar-card", function (e) {
		e.preventDefault();
		var item_code = $(this).data("item-code");
		if (!item_code) {
			return;
		}
		// A parede de /login caiu aqui também (Reserva como visitante —
		// Task 6): o card da listagem abre o mesmo modal para qualquer um.
		frappe.call({
			method: "imunocare_ecommerce.agendamento.booking.info_agendamento",
			args: { item_code: item_code },
			freeze: true,
			callback: function (r) {
				var info = r.message;
				if (!info || !info.agendavel) {
					frappe.msgprint(
						__("Este item ainda não está disponível para agendamento online. Fale com a clínica.")
					);
					return;
				}
				imun_abrir_dialogo_agendamento({ item_code: item_code }, info);
			},
		});
	});
});

// Garante os bundles de formulário do Desk ANTES de montar
// ``frappe.ui.Dialog`` com campos (``fields``) — ver
// feedback_web_dialog_controls_bundle: o ``base_scripts`` padrão do site só
// carrega ``frappe-web.bundle.js`` (tem ``frappe.ui.Dialog``, NÃO tem
// ``frappe.ui.form.make_control``, que só existe em ``controls.bundle``/
// ``desk.bundle``). Sem isso o diálogo estoura
// "frappe.ui.form.make_control is not a function" em qualquer página que não
// inclua os dois bundles no template (hoje só a página do produto,
// ``/cart`` e ``/customer_reviews`` incluem — ``/all-products``, categorias
// e a home NÃO incluem).
//
// Reuso total: ``frappe.require`` já existe em ``frappe-web.bundle.js``
// (``apps/frappe/frappe/website/js/website.js:10-21``, importado por
// ``apps/frappe/frappe/public/js/frappe-web.bundle.js:24`` — presente em
// TODA página pública, sem exceção) e resolve cada nome de bundle
// (``"controls.bundle.js"``/``"dialog.bundle.js"``) para o caminho com hash
// via ``frappe.bundled_asset`` -> ``frappe.boot.assets_json[path]``
// (``website.js:21-29``) — o mesmo ``assets_json`` que
// ``frappe.website.utils.get_boot_data`` injeta no boot de página web
// (``apps/frappe/frappe/website/utils.py:191``, chave ``"assets_json":
// get_assets_json()``), não só no Desk. ``frappe.require`` é ``async
// function`` (website.js:10), então já devolve uma Promise nativamente —
// não precisamos embrulhar em ``new Promise`` nem copiar nenhum template do
// webshop. Ele também deduplica via ``frappe._assets_loaded``
// (website.js:33), então chamar isto de novo num diálogo seguinte não
// insere `<script>` duplicado.
//
// Ponto ÚNICO: usado dentro de ``imun_abrir_dialogo_agendamento`` (abaixo),
// que é o único caminho que todos os chamadores atravessam — botão da
// página do produto (``imun_render_botao_agendar``), cards de listagem
// (``.imun-btn-agendar-card``) e ``window.imunAbrirAgendamentoDialogo``
// (carrossel de médicos, ``medicos_carrossel.bundle.js``) — sem precisar
// tocar em nenhum desses três pontos individualmente nem em template algum.
function imun_garantir_dialog() {
	if (frappe.ui.form && frappe.ui.form.make_control) {
		return Promise.resolve();
	}
	return frappe.require(["controls.bundle.js", "dialog.bundle.js"]);
}

// Diálogo de agendamento compartilhado — aceita ``params`` com
// ``{item_code}`` (item da loja, fluxo A1.3 acima) OU ``{appointment_type}``
// (agendamento direto, ex.: carrossel de médicos na home — R2/Feature 70)
// porque ``agendamento.booking`` já resolve os dois formatos
// (``_resolver_agendavel``). Exposto em ``window.imunAbrirAgendamentoDialogo``
// para outros scripts site-wide reusarem sem duplicar o diálogo inteiro.
//
// ``preset`` (opcional, Reserva como visitante — Task 6): ``{appointment_date,
// appointment_time}`` de uma escolha feita ANTES de identificar/logar —
// preenche o diálogo ao reabrir depois do /login ou depois de uma
// verificação, mas o horário É REVALIDADO normalmente (não fica reservado
// enquanto a pessoa se identifica).
function imun_abrir_dialogo_agendamento(params, info, preset) {
	// Task 1.1 (spec loja-agendar-em-toda-pagina): garante
	// controls.bundle+dialog.bundle ANTES de qualquer coisa que monte
	// frappe.ui.Dialog — cobre TODOS os chamadores desta função (ver
	// imun_garantir_dialog acima).
	imun_garantir_dialog().then(function () {
		// F3 (evoluído na Atividade 542-dep / Feature 72): modalidade "Na clínica
		// x Domiciliar" — consome ``info_domiciliar_agendamento`` (elegibilidade
		// POR SERVIÇO: só oferece Domiciliar quando o Appointment Type do item
		// tiver ``imun_permite_domiciliar=1``, lido defensivamente — ver
		// ``agendamento/domiciliar.py``). Antes desta atividade a elegibilidade
		// era só o flag GLOBAL da loja (``info_domiciliar()``, ainda usado pelo
		// carrinho de produtos em ``domiciliar_cart.js``, sem noção de serviço).
		frappe.call({
			method: "imunocare_ecommerce.agendamento.domiciliar.info_domiciliar_agendamento",
			args: params,
			callback: function (r) {
				imun_montar_dialogo_agendamento(params, info, r.message || {}, preset);
			},
		});
	});
}

// PORQUÊ ISTO EXISTE (fix crítico 2026-09-01 — "Agendar" não abria nada, nem
// para visitante nem para cliente logado, no bench E em produção):
//
// ``frappe.ui.Dialog`` com campo ``fieldtype: "Date"`` é um CONTROLE DE DESK
// (``ControlDate``). Ao montar, ele chama
// ``frappe.datetime.now_date()`` -> ``_date()``
// (frappe/public/js/frappe/utils/datetime.js:237), que lê
// ``frappe.boot.time_zone?.system || frappe.sys_defaults.time_zone``. No
// Desk, ``frappe.sys_defaults`` é atribuído a partir de
// ``frappe.boot.sysdefaults`` no bootstrap (frappe/public/js/frappe/desk.js:321)
// — mas ISSO NUNCA RODA numa página pública da loja. Lá ``frappe.boot`` existe
// (o site injeta), porém sem ``time_zone`` e sem ``sysdefaults``, e
// ``frappe.sys_defaults`` fica simplesmente indefinido. Resultado real:
// ``Cannot read properties of undefined (reading 'time_zone')`` dentro de
// ``make_picker``/``get_now_date``, o diálogo estoura ANTES de exibir
// qualquer coisa (``.modal.show`` nunca aparece no DOM) — não é paranoia,
// foi reproduzido no bench e em produção.
//
// A correção não reimplementa nada do Desk: só PREENCHE o que falta usando o
// que o backend (agendamento.booking.info_agendamento/info_agendamento_tipo,
// função ``_boot_datas``) já devolve — mesmo formato que
// ``frappe.website.utils.get_boot_data`` usa para ``time_zone``
// (system/user). NUNCA sobrescreve valor já existente: no Desk esses campos
// vêm certos e não podem ser mexidos; aqui só entram quando ausentes.
//
// Precisa rodar ANTES de qualquer ``new frappe.ui.Dialog(...)`` que tenha
// campo Date — não só o de agendamento (``appointment_date``), também o de
// identificação do visitante (``dob``/``paciente_dob``, mais abaixo).
function imun_garantir_boot_datas(info) {
	info = info || {};
	frappe.boot = frappe.boot || {};

	if (!frappe.boot.time_zone) {
		if (info.time_zone) {
			frappe.boot.time_zone = info.time_zone;
		} else {
			// Alguns chamadores (ex.: public/js/medicos_carrossel.js — carrossel
			// de médicos da home) montam o ``info`` localmente, SEM passar pelo
			// backend, e por isso nunca trazem time_zone. Sem isso o mesmo
			// ControlDate quebraria ali também. Fuso do navegador é aproximação
			// razoável só para o widget de calendário abrir em "hoje" — a data
			// escolhida vira uma string ``yyyy-mm-dd`` de qualquer forma
			// (get_horarios/criar_agendamento não dependem de fuso).
			var fuso_navegador =
				(window.Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) || "America/Sao_Paulo";
			frappe.boot.time_zone = { system: fuso_navegador, user: fuso_navegador };
		}
	}

	// O datepicker (ControlDate, frappe/form/controls/date.js:50) lê o idioma
	// de ``frappe.boot.user.language`` — que só existe no boot do DESK. No boot
	// de página web (frappe.website.utils.get_boot_data) vem ``lang``, mas não
	// ``user``: sem este espelho o calendário abre em inglês ("September,
	// Su/Mo/Tu") mesmo com o site inteiro em pt-BR. O locale pt-BR JÁ está no
	// controls.bundle ($.fn.datepicker.language["pt-BR"], verificado em prod
	// 2026-09-03) — só falta o ponteiro.
	if (!frappe.boot.user && frappe.boot.lang) {
		frappe.boot.user = { language: frappe.boot.lang };
	}

	frappe.boot.sysdefaults = frappe.boot.sysdefaults || {};
	if (!frappe.boot.sysdefaults.date_format && info.date_format) {
		frappe.boot.sysdefaults.date_format = info.date_format;
	}
	if (!frappe.boot.sysdefaults.time_format && info.time_format) {
		frappe.boot.sysdefaults.time_format = info.time_format;
	}

	// frappe.sys_defaults é o que datetime.js realmente lê em vários pontos
	// (fallback de time_zone, first_day_of_the_week etc.) — só é espelhado a
	// partir de frappe.boot.sysdefaults no bootstrap do Desk, que a loja
	// nunca executa.
	frappe.sys_defaults = frappe.sys_defaults || {};
	frappe.sys_defaults.date_format = frappe.sys_defaults.date_format || frappe.boot.sysdefaults.date_format;
	frappe.sys_defaults.time_format = frappe.sys_defaults.time_format || frappe.boot.sysdefaults.time_format;
	frappe.sys_defaults.time_zone = frappe.sys_defaults.time_zone || frappe.boot.time_zone.system;
}

function imun_montar_dialogo_agendamento(params, info, domiciliar_info, preset) {
	imun_garantir_boot_datas(info);
	var fields = [
		{
			fieldname: "appointment_date",
			// Fonte inglesa "Date" (traduz para "Data" em pt-BR) — NUNCA a fonte
			// ambigua "Data", que colide com o ingles "Data" (=dados/registros) e,
			// com o dicionario de traducao agora injetado na loja, virava "Dados".
			label: "Date",
			fieldtype: "Date",
			reqd: 1,
		},
		{
			fieldname: "horarios_html",
			fieldtype: "HTML",
		},
		{
			fieldname: "appointment_time",
			label: "Selected time",
			fieldtype: "Data",
			read_only: 1,
		},
	];

	// Change venda-sob-receita, task 4.2 (D7/D8) — aviso + confirmação de posse
	// da receita só aparecem quando o item exige receita (info.exige_receita,
	// já resolvido pelo backend na task 4.1). Item não marcado: nenhum campo
	// extra, nenhuma checagem (bifurcação "produto sem exigência" da spec).
	if (info.exige_receita) {
		fields.push({
			fieldname: "imun_receita_sb",
			fieldtype: "Section Break",
		});
		fields.push({
			fieldname: "imun_receita_aviso_html",
			fieldtype: "HTML",
			// Mesma convenção de imun_conferir_cpf_controle (Armadilha 2 do
			// tasks.md / feedback_loja_client_i18n_e_datepicker): texto final já
			// em pt-BR, sem __() — o controle (ControlHTML.get_content também
			// chama __(content), ver imun_passo_colisao_cpf acima) tenta
			// re-traduzir de novo, mas não acha esta string no dicionário
			// (chaves são fonte inglesa) e devolve inalterado.
			options:
				'<p class="text-warning">Este produto exige receita médica — você ' +
				"vai precisar apresentá-la no atendimento.</p>",
		});
		fields.push({
			fieldname: "receita_confirmada",
			fieldtype: "Check",
			label: "Declaro que tenho a receita médica e vou apresentá-la no atendimento.",
		});
	}

	if (domiciliar_info.ativo) {
		fields.push({
			fieldname: "modalidade_sb",
			fieldtype: "Section Break",
		});
		fields.push({
			fieldname: "modalidade",
			label: "Service mode",
			fieldtype: "Select",
			options: __("Na clínica") + "\n" + __("Domiciliar (+ taxa)"),
			default: __("Na clínica"),
			// Task 1.4 (spec loja-agendar-em-toda-pagina): description TAMBÉM é
			// re-traduzida pelo controle (base_input.js:187-199, set_description
			// -> __(this.df.description, ...)) — mesma regra do label. Diferente
			// dos outros description: abaixo, este tem um valor DINÂMICO
			// ({0} = taxa_fmt) — a re-tradução do controle NUNCA recebe
			// `replace`/`$.format` (só chama __(texto, null, parent)), então não
			// dá pra montar o texto final ali. Por isso ainda chamamos __() aqui
			// UMA vez (fonte inglesa, tradução no CSV) só para traduzir+substituir
			// o `{0}` — o resultado já sai em português com o valor certo, e a
			// re-tradução do controle sobre esse texto final (que nunca bate com
			// nenhuma chave do dicionário) não faz nada, igual ao "Date"->"Data"
			// seria um erro se a fonte fosse ambígua — aqui não é.
			description: __(
				"For home visits, the {0} fee is confirmed and charged by reception — this online booking does not charge it automatically yet.",
				[domiciliar_info.taxa_fmt]
			),
		});
	}

	// Item B do spec 2026-09-02-loja-mitigacao-fluxos.md: cliente LOGADO sem
	// Patient completo (ou sem Patient nenhum) — o backend
	// (agendamento.booking.info_agendamento/_status_cadastro_paciente_logado)
	// já devolveu QUAIS campos faltam (dob/cpf/... nunca são deriváveis do
	// User). Em vez de deixar `criar_agendamento` estourar um MandatoryError,
	// coleta esses campos no PRÓPRIO diálogo (mesmos campos/rótulos do passo
	// de identificação do visitante, `imun_passo_identificacao` abaixo) e
	// manda como `patient_data` — o backend já aceita isso para qualquer
	// ramo (ver `agendamento.booking._resolver_paciente`).
	var camposFaltantes =
		(info.logged_in && info.cadastro_paciente && info.cadastro_paciente.campos_faltantes) || [];
	if (camposFaltantes.length) {
		fields.push({ fieldname: "imun_cadastro_sb", fieldtype: "Section Break", label: "Complete your registration" });
		if (camposFaltantes.indexOf("first_name") !== -1 || camposFaltantes.indexOf("last_name") !== -1) {
			fields.push({ fieldname: "imun_nome_completo", fieldtype: "Data", label: "Full name", reqd: 1 });
		}
		if (camposFaltantes.indexOf("dob") !== -1) {
			fields.push({
				fieldname: "imun_dob",
				fieldtype: "Date",
				label: "Date of birth",
				reqd: 1,
				// Tarefa D: abre o calendário ~30 anos atrás em vez do mês
				// atual — também sempre aceitou digitação direta (DD/MM/AAAA),
				// sem depender do calendário.
				options: imun_opcoes_datepicker_nascimento(),
			});
		}
		if (camposFaltantes.indexOf("cpf") !== -1) {
			fields.push({ fieldname: "imun_cpf", fieldtype: "Data", label: "CPF", reqd: 1 });
		}
		if (camposFaltantes.indexOf("mobile") !== -1) {
			fields.push({
				fieldname: "imun_mobile",
				fieldtype: "Data",
				label: "Mobile / WhatsApp",
				reqd: 1,
			});
		}
		if (camposFaltantes.indexOf("email") !== -1) {
			fields.push({
				fieldname: "imun_email",
				fieldtype: "Data",
				options: "Email",
				label: "E-mail",
				reqd: 1,
			});
		}
		if (camposFaltantes.indexOf("sex") !== -1) {
			// Task 1.4 (achado): select.js (parse_option, linhas 172-175) TAMBÉM
			// re-traduz cada linha de `options` (``label = __(v, null,
			// doctype)``) — só o texto exibido no <option>, o VALOR salvo
			// continua o enum bruto ("Male"/"Female"/"Other", o que o
			// Patient.sex do Healthcare espera). Isso é desejável (dropdown em
			// português, valor certo no banco) e dependia do core
			// (frappe/erpnext pt-BR.csv: Male/Female/Other) estar no
			// dicionário — a Task 1.3 (revisão de peso) estreitou o boot para
			// só o CSV do nosso app, o que teria regredido este dropdown para
			// inglês; corrigido incluindo as 3 entradas no nosso próprio CSV
			// (ver translations/pt-BR.csv).
			fields.push({
				fieldname: "imun_sex",
				fieldtype: "Select",
				label: "Gender",
				options: "\nMale\nFemale\nOther",
				reqd: 1,
			});
		}
	}

	var d = new frappe.ui.Dialog({
		// Título genérico (Feature 72): este diálogo compartilhado agenda
		// vacina/vitamina/terapia/consulta — não só "Consulta" (mesmo botão
		// "Agendar" em toda a loja, ver imun_render_botao_agendar/
		// imun_html_botao_agendar_card/medicos_carrossel.js).
		title: __("Agendar"),
		fields: fields,
		primary_action_label: __("Confirmar Agendamento"),
		primary_action: function (values) {
			// Task 3.1 (validacao-cpf-no-navegador) — revalida `imun_cpf` aqui
			// porque dá para clicar "Confirmar Agendamento" sem nunca sair do
			// campo (spec "envio bloqueado sem passar pelo campo"): o `blur`
			// ligado abaixo não teria disparado. `d.fields_dict.imun_cpf` só
			// existe quando o backend pediu o CPF (camposFaltantes) — nos
			// demais ramos (visitante, logado com cadastro completo) o
			// controle é `undefined` e `imun_conferir_cpf_controle` devolve
			// `true` sem examinar nada, então esses ramos não são afetados.
			//
			// Falha para o lado seguro (spec "conferência do navegador em
			// dúvida"): qualquer situação inesperada na conferência não
			// bloqueia o envio — o servidor (`agendamento/booking.py:533`)
			// continua sendo a autoridade.
			try {
				if (!imun_conferir_cpf_controle(d.fields_dict.imun_cpf)) {
					// Bloqueia só não chamando o servidor: diálogo permanece
					// aberto e com tudo o que foi digitado (spec) — sem
					// `msgprint`/`frappe.throw`, a marca no campo já avisa.
					return;
				}
			} catch (e) {
				// Dúvida da própria conferência: segue adiante, quem decide
				// de verdade é o servidor.
			}
			if (!values.appointment_time) {
				frappe.msgprint(__("Selecione um horário disponível."));
				return;
			}

			// Change venda-sob-receita, task 4.2 (D7) — mesmo padrão de bloqueio
			// client-side dos demais campos obrigatórios do modal (aponta o
			// campo, não dispara o envio): sem a confirmação marcada, nem o
			// logado nem o visitante avançam — a ramificação de guest logo
			// abaixo (imun_passo_identificacao) herda `values.receita_confirmada`
			// deste MESMO diálogo, então validar aqui cobre os dois caminhos.
			if (info.exige_receita && !values.receita_confirmada) {
				var controleReceita = d.fields_dict.receita_confirmada;
				if (controleReceita) {
					controleReceita.df.invalid = true;
					controleReceita.set_invalid();
					controleReceita.set_description(
						"Marque a confirmação de que você tem a receita médica para continuar."
					);
				}
				return;
			}

			var domiciliar = domiciliar_info.ativo && values.modalidade === __("Domiciliar (+ taxa)");

			// Reserva como visitante (Task 6): guest chegou até o Confirmar
			// sem logar — ramifica para identificação/verificação em vez de
			// chamar criar_agendamento direto (que recusa Guest). O horário
			// escolhido aqui é só a INTENÇÃO; confirmar_codigo_e_agendar é
			// quem de fato cria o agendamento, já logado.
			if (!info.logged_in) {
				imun_passo_identificacao(d, params, info, values, domiciliar);
				return;
			}

			// Monta patient_data SOMENTE com o que o backend disse faltar
			// (camposFaltantes, calculado ao montar o diálogo) — nunca manda
			// campos que o Patient/User já resolveria sozinho, e nunca
			// sobrescreve dado existente do cliente.
			var patient_data = null;
			if (camposFaltantes.length) {
				patient_data = {};
				if (values.imun_nome_completo) {
					patient_data.nome_completo = values.imun_nome_completo;
				}
				if (values.imun_dob) {
					patient_data.dob = values.imun_dob;
				}
				if (values.imun_cpf) {
					patient_data.cpf = values.imun_cpf;
				}
				if (values.imun_mobile) {
					patient_data.mobile = values.imun_mobile;
				}
				if (values.imun_email) {
					patient_data.email = values.imun_email;
				}
				if (values.imun_sex) {
					patient_data.sex = values.imun_sex;
				}
			}

			var escolhaAtual = {
				item_code: params.item_code,
				appointment_type: params.appointment_type,
				practitioner: info.practitioner,
				appointment_date: values.appointment_date,
				appointment_time: values.appointment_time,
				modalidade: domiciliar ? "Domiciliar" : "Na Clínica",
				// Change venda-sob-receita, task 4.2 (D7) — atravessa a colisão de
				// CPF (imun_passo_colisao_cpf) até o dados do OTP, ver abaixo.
				receita_confirmada: !!values.receita_confirmada,
			};

			frappe.call({
				method: "imunocare_ecommerce.agendamento.booking.criar_agendamento",
				args: Object.assign(
					{
						appointment_date: values.appointment_date,
						appointment_time: values.appointment_time,
						practitioner: info.practitioner,
						modalidade: domiciliar ? "Domiciliar" : "Na Clínica",
						patient_data: patient_data,
						// Rastreio da jornada (Feature 56 / A2.4) — null se o cliente não
						// consentiu, e o agendamento segue normalmente sem UTM/origem.
						session_id: window.ImunRastreio ? window.ImunRastreio.sessionId() : null,
						// Change venda-sob-receita, task 4.2 (D7) — caminho logado direto
						// (sem colisão de CPF); o servidor confere de novo (criar_agendamento).
						receita_confirmada: !!values.receita_confirmada,
					},
					params
				),
				freeze: true,
				freeze_message: __("Agendando..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					// Tarefa B do spec 2026-09-03-cadastro-paciente-portal-e-colisao-cpf.md:
					// o CPF digitado já é de um Patient existente (órfão) — em vez do
					// erro cru de CPF duplicado, o backend pede para confirmar a
					// identidade por um código de verificação ANTES de vincular esse
					// Patient à conta logada e concluir ESTE MESMO agendamento.
					if (r.message.precisa_verificacao) {
						d.hide();
						imun_passo_colisao_cpf(escolhaAtual, values.imun_cpf || "");
						return;
					}
					d.hide();
					imun_finalizar_sucesso_agendamento(r.message);
				},
			});
		},
	});

	d.fields_dict.appointment_date.$input.on("change", function () {
		var data = d.get_value("appointment_date");
		if (!data) {
			return;
		}
		var $wrap = d.fields_dict.horarios_html.$wrapper;
		$wrap.html('<div class="text-muted">' + __("Consultando horários...") + "</div>");
		d.set_value("appointment_time", "");

		frappe.call({
			method: "imunocare_ecommerce.agendamento.booking.get_horarios",
			args: Object.assign({ data: data, practitioner: info.practitioner }, params),
			callback: function (r) {
				imun_render_horarios(d, r.message || {});
			},
		});
	});

	// Task 3.1 (validacao-cpf-no-navegador) — conferência de CPF no blur do
	// campo `imun_cpf` deste diálogo, injetado só quando o backend pediu o
	// CPF (camposFaltantes acima). `d.fields_dict.imun_cpf` fica `undefined`
	// nos demais ramos, e o `if` dentro do auxiliar cobre essa ausência —
	// reaproveita o mesmo auxiliar das tasks 2.1/2.2, sem duplicar lógica.
	imun_ligar_conferencia_cpf(d.fields_dict.imun_cpf);

	// Change venda-sob-receita, task 4.2 — limpa a marca de campo faltante
	// assim que a pessoa marca a confirmação (sem precisar clicar Confirmar
	// de novo pra ver o aviso sumir); `d.fields_dict.receita_confirmada` só
	// existe quando `info.exige_receita` empurrou o campo (acima).
	if (d.fields_dict.receita_confirmada) {
		d.fields_dict.receita_confirmada.$input.on("change", function () {
			var controle = d.fields_dict.receita_confirmada;
			if (controle.get_value()) {
				controle.df.invalid = false;
				controle.set_invalid();
				controle.set_description("");
			}
		});
	}

	d.show();
	imun_registrar_modal_para_esc(d);

	// Reabertura pós-login/verificação (Task 6): repõe a escolha de data/hora
	// de antes de identificar — o listener de "change" acima revalida o
	// horário no backend (get_horarios), porque ele NÃO ficou reservado
	// enquanto a pessoa se verificava.
	if (preset) {
		d.set_value("appointment_date", preset.appointment_date);
		d.set_value("appointment_time", preset.appointment_time);
	}
}

// Sucesso do agendamento — compartilhado entre o caminho direto (logado sem
// colisão) e o fim do fluxo de colisão de CPF (imun_passo_codigo_vinculo_logado),
// que devolve o MESMO shape de resultado de criar_agendamento.
function imun_finalizar_sucesso_agendamento(resultado) {
	if (resultado.payment_url) {
		window.location.href = resultado.payment_url;
		return;
	}
	var mensagem = __(
		"Seu agendamento ({0}) foi registrado. Nossa equipe entrará em contato para combinar o pagamento.",
		[resultado.appointment]
	);
	if (resultado.aviso_domiciliar) {
		mensagem += "<br><br>" + frappe.utils.escape_html(resultado.aviso_domiciliar);
	}
	frappe.msgprint({
		title: __("Agendamento confirmado"),
		message: mensagem,
		indicator: "green",
	});
}

// ---------------------------------------------------------------------------
// Colisão de CPF do usuário LOGADO (Tarefa B do spec
// 2026-09-03-cadastro-paciente-portal-e-colisao-cpf.md) — reuso do MESMO
// motor de OTP da reserva como visitante (imunocare_ecommerce.conta.verificacao):
// ``solicitar_codigo`` já manda o código para o contato DO CADASTRO quando o
// CPF digitado já existe (nunca para o que a pessoa digitar aqui) — nenhuma
// mudança nesse endpoint foi necessária. Só o passo de CONFIRMAÇÃO é novo
// (``confirmar_codigo_e_vincular_logado``): vincula o Patient órfão à conta
// JÁ LOGADA (nunca cria User novo, nunca reloga).
// ---------------------------------------------------------------------------

function imun_passo_colisao_cpf(escolha, cpfDigitado) {
	var avancouParaCodigo = false;
	var d2 = new frappe.ui.Dialog({
		title: __("Confirme sua identidade"),
		fields: [
			{
				fieldtype: "HTML",
				// Task 1.4 (achado): frappe/public/js/frappe/form/controls/html.js
				// (ControlHTML.get_content, linhas 9-11) TAMBÉM re-traduz
				// `options` (``content = __(content)``), contrariando a
				// suposição inicial de que HTML field escaparia da regra. Na
				// prática é inofensivo aqui: a chave que a re-tradução tenta
				// achar é a STRING INTEIRA já com as tags <p> — nunca bate com
				// nenhuma entrada do CSV (que só tem texto puro), então a
				// re-tradução é sempre um no-op. Convertê-lo para "fonte
				// inglesa sem __()" exigiria colocar HTML cru como chave do CSV
				// (frágil, propenso a quebrar com aspas/novas linhas) só para
				// remover uma re-tradução que já não faz nada — mantido com
				// __() de propósito; ver relatório da Task 1.4.
				options:
					"<p>" +
					__(
						"Este CPF já está cadastrado. Para vincular à sua conta e concluir o agendamento, confirme com um código de verificação."
					) +
					"</p>",
			},
			{
				fieldname: "canal",
				fieldtype: "Select",
				label: "Receive the code by",
				reqd: 1,
				// Task 1.4: description sem __() aqui — a mesma regra do label
				// (fonte inglesa, o controle traduz sozinho, ver base_input.js:
				// set_description -> __(this.df.description, ...)).
				description: "The code goes to the contact already ON FILE — not to what you type below.",
			},
			{
				fieldname: "email",
				fieldtype: "Data",
				options: "Email",
				label: "E-mail",
				depends_on: "eval:doc.canal=='" + __("E-mail") + "'",
				mandatory_depends_on: "eval:doc.canal=='" + __("E-mail") + "'",
			},
			{
				fieldname: "celular",
				fieldtype: "Data",
				label: "Mobile / WhatsApp",
				depends_on: "eval:doc.canal=='" + __("WhatsApp") + "'",
				mandatory_depends_on: "eval:doc.canal=='" + __("WhatsApp") + "'",
			},
		],
		primary_action_label: __("Receber código"),
		primary_action: function (v) {
			var canalEfetivo = v.canal === __("WhatsApp") ? "whatsapp" : "email";
			var dados = {
				cpf: cpfDigitado,
				email: v.email,
				celular: v.celular,
				// Change venda-sob-receita, task 4.2 (D7) — a confirmação foi
				// marcada (ou não exigida) no diálogo de agendamento, ANTES da
				// colisão de CPF surgir; viaja aqui dentro do payload do OTP
				// (mesmo mecanismo do cache do Redis) para
				// confirmar_codigo_e_vincular_logado repassar a
				// criar_agendamento.
				receita_confirmada: !!escolha.receita_confirmada,
			};
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.solicitar_codigo",
				args: { canal: canalEfetivo, dados: dados },
				freeze: true,
				freeze_message: __("Enviando código..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					avancouParaCodigo = true;
					d2.hide();
					imun_passo_codigo_vinculo_logado(escolha, r.message, { canal: canalEfetivo, dados: dados });
				},
			});
		},
		on_hide: function () {
			if (!avancouParaCodigo) {
				frappe.show_alert({
					message: __("Agendamento não confirmado — verificação cancelada."),
					indicator: "orange",
				});
			}
		},
	});

	// O seletor só oferece o canal que está operacional AGORA (mesmo padrão
	// do passo de identificação do guest, imun_passo_identificacao).
	frappe.call({
		method: "imunocare_ecommerce.conta.verificacao.canais_disponiveis",
		callback: function (r) {
			var opcoes = [];
			if ((r.message || {}).whatsapp) {
				opcoes.push(__("WhatsApp"));
			}
			if ((r.message || {}).email) {
				opcoes.push(__("E-mail"));
			}
			d2.set_df_property("canal", "options", opcoes.join("\n"));
			if (opcoes.length === 1) {
				d2.set_value("canal", opcoes[0]);
			}
		},
	});

	d2.show();
	imun_registrar_modal_para_esc(d2);
}

function imun_passo_codigo_vinculo_logado(escolha, envio, reenvio) {
	var concluido = false;
	var d3 = new frappe.ui.Dialog({
		title: __("Digite o código"),
		fields: [
			{ fieldname: "aviso_html", fieldtype: "HTML" },
			{ fieldname: "codigo", fieldtype: "Data", label: "6-digit code", reqd: 1 },
		],
		primary_action_label: __("Confirmar agendamento"),
		primary_action: function (v) {
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.confirmar_codigo_e_vincular_logado",
				args: {
					codigo: v.codigo,
					verificacao_id: envio.verificacao_id,
					appointment_date: escolha.appointment_date,
					appointment_time: escolha.appointment_time,
					item_code: escolha.item_code,
					appointment_type: escolha.appointment_type,
					practitioner: escolha.practitioner,
					modalidade: escolha.modalidade,
					session_id: window.ImunRastreio ? window.ImunRastreio.sessionId() : null,
				},
				freeze: true,
				freeze_message: __("Confirmando..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					concluido = true;
					d3.hide();
					imun_finalizar_sucesso_agendamento(r.message);
				},
			});
		},
		secondary_action_label: __("Reenviar código"),
		secondary_action: function () {
			if (!reenvio) {
				return;
			}
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.solicitar_codigo",
				args: Object.assign({}, reenvio, { verificacao_id_anterior: envio.verificacao_id }),
				freeze: true,
				freeze_message: __("Reenviando código..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					envio = r.message;
					imun_atualizar_aviso_codigo(d3, envio);
					d3.set_value("codigo", "");
					frappe.show_alert({ message: __("Novo código enviado."), indicator: "green" });
				},
			});
		},
		on_hide: function () {
			if (!concluido) {
				frappe.show_alert({
					message: __("Agendamento não confirmado — verificação cancelada."),
					indicator: "orange",
				});
			}
		},
	});
	imun_atualizar_aviso_codigo(d3, envio);
	d3.show();
	imun_registrar_modal_para_esc(d3);
}

function imun_render_horarios(d, res) {
	var $wrap = d.fields_dict.horarios_html.$wrapper;
	if (res.aviso) {
		$wrap.html('<div class="text-muted">' + frappe.utils.escape_html(res.aviso) + "</div>");
		return;
	}
	if (!res.horarios || !res.horarios.length) {
		$wrap.html('<div class="text-muted">' + __("Nenhum horário livre nesta data.") + "</div>");
		return;
	}
	var html = res.horarios
		.map(function (h) {
			return (
				'<button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1 imun-slot-btn" data-hora="' +
				h.hora +
				'">' +
				h.hora.slice(0, 5) +
				"</button>"
			);
		})
		.join("");
	$wrap.html(html);
	$wrap.on("click", ".imun-slot-btn", function () {
		$wrap.find(".imun-slot-btn").removeClass("btn-primary").addClass("btn-outline-primary");
		$(this).removeClass("btn-outline-primary").addClass("btn-primary");
		d.set_value("appointment_time", $(this).data("hora"));
	});
}

// ---------------------------------------------------------------------------
// Conferência de CPF no navegador — Feature validacao-cpf-no-navegador,
// task 2.1. Auxiliar reaproveitável (a task 3.1 liga o mesmo gancho ao
// campo `imun_cpf` do modal de agendamento): liga UM controle de campo Data
// à conferência de `imun_cpf.js` no `blur`.
//
// Armadilha 1 (tasks.md): campo Data dispara `onchange` no `change` E no
// `input` com debounce de 500ms (base_input.js ~184-186) — `onchange`
// acusaria "CPF inválido" no meio da digitação (5 dígitos), o que o dono já
// recusou. Por isso prendemos no `blur` do `$input`, que só dispara quando
// a pessoa sai do campo de fato — nunca no meio da digitação.
//
// Falha para o lado seguro (spec "conferência do navegador em dúvida" /
// "o servidor continua sendo a autoridade"): controle ausente, sem
// `$input`, ou qualquer situação inesperada não deve travar o formulário —
// só não liga a conveniência, e quem decide de verdade continua sendo o
// servidor.
//
// Task 2.2 — a parte "marcar/limpar" foi separada em
// `imun_conferir_cpf_controle` para ser reaproveitada também no
// `primary_action` do diálogo (revalidação de quem envia sem sair do
// campo), sem duplicar o bloco de marcação. O comportamento do `blur`
// abaixo continua idêntico ao da task 2.1.
//
// Devolve `true` quando o valor pode seguir (vazio ou válido) e `false`
// quando bloqueia (CPF com dígito verificador errado). `controle` ausente
// também devolve `true` — dúvida da própria conferência nunca barra
// (spec "conferência do navegador em dúvida").
function imun_conferir_cpf_controle(controle, mensagem_invalido) {
	if (!controle) {
		return true;
	}
	var mensagem = mensagem_invalido || "CPF inválido.";
	var valor = controle.get_value();
	// Campo vazio: quem cuida é o `reqd` nativo — nunca "CPF inválido"
	// (spec "campo de CPF em branco"). Limpa qualquer marca anterior,
	// senão um erro corrigido para vazio fica preso na tela.
	if (!valor) {
		controle.df.invalid = false;
		controle.set_invalid();
		controle.set_description("");
		return true;
	}
	if (imun_cpf_valido(valor)) {
		// CPF aceito: limpa marca antiga e reescreve formatado (spec
		// "CPF aceito é devolvido formatado").
		controle.df.invalid = false;
		controle.set_invalid();
		controle.set_description("");
		controle.set_value(imun_formatar_cpf(valor));
		return true;
	}
	controle.df.invalid = true;
	controle.set_invalid();
	// Armadilha 2 (tasks.md): `set_description` passa o texto por `__()`
	// (base_input.js ~195), que não traduz na loja
	// (feedback_loja_client_i18n_e_datepicker) — mensagem já nasce em
	// pt-BR aqui, sem __().
	controle.set_description(mensagem);
	return false;
}

function imun_ligar_conferencia_cpf(controle, mensagem_invalido) {
	if (!controle || !controle.$input) {
		return;
	}
	controle.$input.on("blur", function () {
		imun_conferir_cpf_controle(controle, mensagem_invalido);
	});
}

// ---------------------------------------------------------------------------
// Reserva como visitante (Task 6) — identificação + código, dentro do
// próprio modal. Backend: imunocare_ecommerce.conta.verificacao (Tasks 4/5).
// ---------------------------------------------------------------------------

// Guest que chegou ao Confirmar: escolhe entrar na conta ou se verificar.
// ``info`` é o mesmo objeto que o clique original montou (item da loja OU
// carrossel de médicos) — carregamos ``info.practitioner`` na escolha para
// que o fluxo por ``appointment_type`` (sem Website Item) consiga resolver o
// profissional em ``confirmar_codigo_e_agendar`` sem depender do "só existe
// 1 Practitioner Ativo" (ver agendamento.booking._resolver_practitioner).
function imun_passo_identificacao(dialogo, params, info, values, domiciliar) {
	// Este diálogo também tem campos Date (dob/paciente_dob) — mesma
	// quebra do ControlDate na loja (ver imun_garantir_boot_datas acima).
	// Idempotente/nunca sobrescreve: repetir aqui é seguro mesmo já tendo
	// rodado ao montar o diálogo de agendamento.
	imun_garantir_boot_datas(info);
	var escolha = {
		item_code: params.item_code,
		appointment_type: params.appointment_type,
		practitioner: info.practitioner,
		appointment_date: values.appointment_date,
		appointment_time: values.appointment_time,
		modalidade: domiciliar ? "Domiciliar" : "Na Clínica",
	};
	// Sobrevive ao page load do /login (botão "Já tenho conta") e a um
	// reload após "horário sumiu" (ver o error: do passo do código). Limpo no
	// on_hide dos dois diálogos abaixo quando a pessoa DESISTE (fecha sem
	// avançar) — não só ao fechar a aba.
	imun_guardar_reserva_pendente(escolha);

	dialogo.hide();
	var avancouParaCodigo = false;
	var d2 = new frappe.ui.Dialog({
		title: __("Quase lá"),
		fields: [
			{
				fieldtype: "HTML",
				// Task 1.4: mesmo caso de imun_passo_colisao_cpf acima — options
				// de HTML field É re-traduzido (html.js:9-11), mas com tag <p>
				// embutida nunca bate chave do CSV; mantido com __() de propósito.
				options: "<p>" + __("Para confirmar o horário escolhido, identifique-se.") + "</p>",
			},
			{ fieldname: "ja_tenho_conta", fieldtype: "Button", label: "I already have an account" },
			{ fieldtype: "Section Break" },
			{ fieldname: "nome", fieldtype: "Data", label: "Full name", reqd: 1 },
			{ fieldname: "celular", fieldtype: "Data", label: "Mobile / WhatsApp", reqd: 1 },
			{ fieldname: "email", fieldtype: "Data", label: "E-mail", options: "Email", reqd: 1 },
			{ fieldname: "cpf", fieldtype: "Data", label: "CPF", reqd: 1 },
			{
				fieldname: "dob",
				fieldtype: "Date",
				label: "Date of birth",
				reqd: 1,
				// Tarefa D: quem se verifica aqui é sempre maior de 18
				// (_exigir_adulto) — abre o calendário ~30 anos atrás em vez
				// do mês atual. Digitar direto (DD/MM/AAAA) já funcionava.
				options: imun_opcoes_datepicker_nascimento(),
			},
			{
				fieldname: "sexo",
				fieldtype: "Select",
				label: "Gender",
				options: "\nMale\nFemale\nOther",
				reqd: 1,
			},
			{
				fieldname: "para_outra_pessoa",
				fieldtype: "Check",
				label: "This appointment is for someone else",
				// Task 1.4: description sem __() — mesma regra do label.
				description:
					"Minors can only be booked by a guardian — check this box and enter the patient's details.",
			},
			{
				fieldname: "paciente_nome",
				fieldtype: "Data",
				label: "Patient's name",
				depends_on: "para_outra_pessoa",
				mandatory_depends_on: "para_outra_pessoa",
			},
			{
				fieldname: "paciente_cpf",
				fieldtype: "Data",
				label: "Patient's CPF",
				depends_on: "para_outra_pessoa",
				mandatory_depends_on: "para_outra_pessoa",
			},
			{
				fieldname: "paciente_dob",
				fieldtype: "Date",
				label: "Patient's date of birth",
				depends_on: "para_outra_pessoa",
				mandatory_depends_on: "para_outra_pessoa",
			},
			{
				fieldname: "paciente_sexo",
				fieldtype: "Select",
				label: "Patient's gender",
				options: "\nMale\nFemale\nOther",
				depends_on: "para_outra_pessoa",
				mandatory_depends_on: "para_outra_pessoa",
			},
			{ fieldtype: "Section Break" },
			{
				fieldname: "canal",
				fieldtype: "Select",
				label: "Receive the code by",
				reqd: 1,
				// Mudança de contrato (revisão de segurança 2026-09-01): o canal
				// não é cosmético — é ele que ANCORA a conta. Verificar por
				// WhatsApp identifica pelo CELULAR; por e-mail, pelo E-MAIL. Quem
				// já tem conta de e-mail e verifica por WhatsApp pode entrar numa
				// conta nova, não na antiga.
				// Task 1.4: description sem __() — mesma regra do label.
				description:
					"The contact you confirm here is what opens/identifies your account — not the other field on the form.",
			},
		],
		primary_action_label: __("Receber código"),
		primary_action: function (v) {
			// Task 2.2 (validacao-cpf-no-navegador) — revalida os dois campos
			// aqui porque dá para clicar "Receber código" sem nunca sair do
			// campo (spec "envio bloqueado sem passar pelo campo"): o `blur`
			// da task 2.1 não teria disparado. `paciente_cpf` só entra na
			// conferência quando `para_outra_pessoa` está marcado — mesmo
			// recorte do portão do servidor
			// (conta/verificacao.py:80 `_validar_cpf_dados`), que continua
			// intocado e é quem decide de verdade.
			//
			// Falha para o lado seguro (spec "conferência do navegador em
			// dúvida"): qualquer situação inesperada na conferência não
			// bloqueia o envio — só não barra por dúvida própria, o servidor
			// segue como autoridade.
			try {
				var cpfOk = imun_conferir_cpf_controle(d2.fields_dict.cpf);
				var pacienteCpfOk = true;
				if (v.para_outra_pessoa) {
					pacienteCpfOk = imun_conferir_cpf_controle(
						d2.fields_dict.paciente_cpf,
						"CPF do paciente inválido."
					);
				}
				if (!cpfOk || !pacienteCpfOk) {
					// Bloqueia só não chamando o servidor: diálogo permanece
					// aberto e com tudo o que foi digitado (spec) — sem
					// `msgprint`/`frappe.throw`, a marca no campo já avisa.
					return;
				}
			} catch (e) {
				// Dúvida da própria conferência: segue adiante, quem decide
				// de verdade é o servidor.
			}
			var canalEfetivo = v.canal === __("WhatsApp") ? "whatsapp" : "email";
			// Change venda-sob-receita, task 4.2 (D7) — a checkbox de confirmação
			// vive no diálogo ANTERIOR (imun_montar_dialogo_agendamento, `values`
			// aqui é o parâmetro desta função, não `v` deste diálogo de
			// identificação) — precisa ser injetada explicitamente no payload do
			// OTP, senão some entre um diálogo e o outro (regra fechada pela
			// metade). O MESMO objeto alimenta o envio inicial e o reenvio de
			// código, para o "Reenviar código" não perder a confirmação.
			var dadosComReceita = Object.assign({}, v, {
				receita_confirmada: !!values.receita_confirmada,
			});
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.solicitar_codigo",
				args: { canal: canalEfetivo, dados: dadosComReceita },
				freeze: true,
				freeze_message: __("Enviando código..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					avancouParaCodigo = true;
					d2.hide();
					imun_passo_codigo(escolha, r.message, { canal: canalEfetivo, dados: dadosComReceita });
				},
			});
		},
		on_hide: function () {
			// Fechou sem avançar (X, backdrop, Esc) = desistiu — não deixa a
			// escolha pendente reabrir o modal sozinho depois.
			if (!avancouParaCodigo) {
				imun_limpar_reserva_pendente();
			}
		},
	});

	// Task 2.1 (validacao-cpf-no-navegador) — conferência de CPF no blur dos
	// dois campos deste diálogo. `paciente_cpf` fica `undefined` quando o
	// campo ainda não foi renderizado no DOM (não é o caso aqui, Dialog já
	// monta todos os fields_dict na construção) — o `if` dentro do
	// auxiliar cobre qualquer ausência mesmo assim.
	imun_ligar_conferencia_cpf(d2.fields_dict.cpf);
	imun_ligar_conferencia_cpf(d2.fields_dict.paciente_cpf, "CPF do paciente inválido.");

	d2.fields_dict.ja_tenho_conta.$input.on("click", function () {
		window.location.href = "/login?redirect-to=" + encodeURIComponent(window.location.pathname);
	});

	// O seletor só oferece o canal que está operacional AGORA.
	frappe.call({
		method: "imunocare_ecommerce.conta.verificacao.canais_disponiveis",
		callback: function (r) {
			var opcoes = [];
			if ((r.message || {}).whatsapp) {
				opcoes.push(__("WhatsApp"));
			}
			if ((r.message || {}).email) {
				opcoes.push(__("E-mail"));
			}
			d2.set_df_property("canal", "options", opcoes.join("\n"));
			if (opcoes.length === 1) {
				d2.set_value("canal", opcoes[0]);
			}
		},
	});

	d2.show();
	imun_registrar_modal_para_esc(d2);
}

// Passo do código — ``reenvio`` guarda {canal, dados} da última chamada a
// ``solicitar_codigo`` para o botão "Reenviar código" reenviar o mesmo
// formulário. Cada emissão vira uma chave PRÓPRIA no Redis (não sobrescreve
// mais nenhuma outra) — por isso o reenvio manda também
// ``verificacao_id_anterior`` (o ``envio.verificacao_id`` corrente, lido no
// clique) para o servidor descartar a verificação velha antes de emitir a
// nova (ver conta/verificacao.py:_descartar_verificacao_anterior).
function imun_passo_codigo(escolha, envio, reenvio) {
	var concluido = false;
	var recarregando = false;
	var d3 = new frappe.ui.Dialog({
		title: __("Digite o código"),
		fields: [
			{ fieldname: "aviso_html", fieldtype: "HTML" },
			{ fieldname: "codigo", fieldtype: "Data", label: "6-digit code", reqd: 1 },
		],
		primary_action_label: __("Confirmar reserva"),
		primary_action: function (v) {
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.confirmar_codigo_e_agendar",
				args: {
					codigo: v.codigo,
					// envio.verificacao_id é lido no momento do clique, não na criação
					// do diálogo — "Reenviar código" reatribui envio (abaixo) com um
					// token NOVO, e o antigo tem que ser descartado (é a chave que
					// muda no Redis a cada emissão).
					verificacao_id: envio.verificacao_id,
					appointment_date: escolha.appointment_date,
					appointment_time: escolha.appointment_time,
					item_code: escolha.item_code,
					appointment_type: escolha.appointment_type,
					practitioner: escolha.practitioner,
					modalidade: escolha.modalidade,
					session_id: window.ImunRastreio ? window.ImunRastreio.sessionId() : null,
				},
				freeze: true,
				freeze_message: __("Confirmando..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					concluido = true;
					imun_limpar_reserva_pendente();
					d3.hide();
					imun_mensagem_confirmacao_guest(r.message);
				},
				error: function (r) {
					// Código errado/expirado/bloqueado e "menor sem responsável"
					// acontecem ANTES do login (dentro de
					// confirmar_codigo_e_agendar, antes de _garantir_usuario) — a
					// mensagem do servidor já aparece sozinha (frappe.call mostra
					// _server_messages mesmo com este `error` custom, ver
					// frappe/public/js/frappe/request.js:cleanup); não duplicamos
					// a regra aqui, só não engolimos o erro (não fazemos nada:
					// dialogo continua aberto, campo código pronto pra nova
					// tentativa/reenvio).
					//
					// O ÚNICO caso tratado aqui é o esperado do passo 5: horário
					// tomado enquanto a pessoa digitava o código. Esse ponto só é
					// alcançado DEPOIS de login_as/criação de conta — a pessoa
					// perde o horário, nunca o cadastro. Identificado pela classe
					// de exceção do healthcare (Patient Appointment.
					// validate_overlaps), não pelo texto da mensagem.
					var exc = r && r.exc_type;
					if (exc !== "OverlapError" && exc !== "MaximumCapacityError") {
						return;
					}
					recarregando = true;
					d3.hide();
					// Item 6 da revisão 2026-09-01: OverlapError do healthcare
					// (patient_appointment.py:validate_overlaps) não significa só
					// "outra pessoa preencheu esse horário" — o mesmo erro cobre
					// "você (o mesmo paciente) já tem uma consulta nesse dia". A
					// mensagem cobre os dois sentidos sem afirmar qual foi.
					frappe.msgprint({
						title: __("Não foi possível confirmar este horário"),
						message: __(
							"Esse horário pode ter sido preenchido por outra pessoa, ou você já tem uma consulta marcada para esse dia. Sua conta já está criada e você está conectado — escolha outro horário."
						),
						indicator: "orange",
					});
					// Recarrega para o front enxergar a sessão nova e reabrir o
					// modal já logado, com a data revalidada. Timestamp novo: essa
					// escolha acabou de nascer, não herda a idade da anterior.
					imun_guardar_reserva_pendente(escolha);
					setTimeout(function () {
						window.location.reload();
					}, 2500);
				},
			});
		},
		secondary_action_label: __("Reenviar código"),
		secondary_action: function () {
			if (!reenvio) {
				return;
			}
			frappe.call({
				method: "imunocare_ecommerce.conta.verificacao.solicitar_codigo",
				// verificacao_id_anterior = o token que ainda está com a pessoa
				// nessa hora (lido de ``envio``, não de ``reenvio``, que nunca muda) —
				// o servidor descarta essa chave velha antes de emitir a nova.
				args: Object.assign({}, reenvio, { verificacao_id_anterior: envio.verificacao_id }),
				freeze: true,
				freeze_message: __("Reenviando código..."),
				callback: function (r) {
					if (!r.message) {
						return;
					}
					envio = r.message;
					imun_atualizar_aviso_codigo(d3, envio);
					d3.set_value("codigo", "");
					frappe.show_alert({ message: __("Novo código enviado."), indicator: "green" });
				},
			});
		},
		on_hide: function () {
			// Fechou sem confirmar e sem cair no caso "horário sumiu" (que já
			// regrava a escolha pendente sozinho) = desistiu de verdade.
			if (!concluido && !recarregando) {
				imun_limpar_reserva_pendente();
			}
		},
	});
	imun_atualizar_aviso_codigo(d3, envio);
	d3.show();
	imun_registrar_modal_para_esc(d3);
}

function imun_atualizar_aviso_codigo(d3, envio) {
	d3.fields_dict.aviso_html.$wrapper.html(
		"<p>" +
			__("Enviamos um código para {0}. Ele vale por 10 minutos.", [
				frappe.utils.escape_html(envio.destino_mascarado),
			]) +
			"</p>"
	);
}

// Mensagem final do fluxo de visitante — mesmo shape de resultado de
// criar_agendamento (payment_url/aviso_domiciliar), acrescido de
// ``conta_criada`` (Task 5): diferencia "criamos sua conta" de "você entrou
// numa conta que já existia" (ex.: CPF já cadastrado, ou celular/e-mail já
// era de um Website User).
function imun_mensagem_confirmacao_guest(resultado) {
	if (resultado.payment_url) {
		window.location.href = resultado.payment_url;
		return;
	}
	var contaMsg = resultado.conta_criada
		? __("Criamos sua conta para você acompanhar este e outros agendamentos.")
		: __("Você entrou na conta que já tinha conosco.");
	var mensagem = __(
		"Seu agendamento ({0}) foi registrado. Nossa equipe entrará em contato para combinar o pagamento.",
		[resultado.appointment]
	);
	mensagem += "<br><br>" + contaMsg;
	if (resultado.aviso_domiciliar) {
		mensagem += "<br><br>" + frappe.utils.escape_html(resultado.aviso_domiciliar);
	}

	// Item 1 da revisão 2026-09-01: frappe.session.user foi lido no
	// carregamento da página e continua "Guest" no cliente mesmo depois de
	// confirmar_codigo_e_agendar logar a pessoa no servidor — o cabeçalho do
	// site seguiria mostrando "Entrar" para quem acabou de criar conta.
	// Atualiza o valor em memória com o que o backend REALMENTE logou
	// (``resultado.usuario`` — nunca adivinhado no cliente) e recarrega a
	// página para o cabeçalho refletir a sessão nova. O reload só acontece
	// quando este diálogo FECHA (custom_onhide, disparado por qualquer jeito
	// de fechar — botão OK, X, clique fora, ESC): a pessoa sempre lê a
	// mensagem de sucesso antes, nunca pisca.
	if (resultado.usuario) {
		frappe.session.user = resultado.usuario;
	}
	var dialogo = frappe.msgprint({
		title: __("Reserva confirmada"),
		message: mensagem,
		indicator: "green",
	});
	if (resultado.usuario && dialogo) {
		dialogo.custom_onhide = function () {
			window.location.reload();
		};
	}
}

// Reuso site-wide (R2/Feature 70 — carrossel de médicos na home,
// public/js/medicos_carrossel.js): mesmo diálogo de agendamento, sem
// duplicar a lógica de disponibilidade/confirmação acima.
window.imunAbrirAgendamentoDialogo = imun_abrir_dialogo_agendamento;
